// Copy any generated snippet while leaving draft and saved store settings untouched
export const copyCode = async (label, code, toastSuccess, toastError) => {

    try {

        // Prefer the modern clipboard API on secure pages
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(code);
        } else {

            // Support local development pages which lack secure clipboard access
            const temporaryInput = document.createElement("textarea");
            temporaryInput.value = code;
            temporaryInput.style.position = "fixed";
            temporaryInput.style.opacity = "0";
            document.body.appendChild(temporaryInput);
            temporaryInput.select();
            const didCopy = document.execCommand("copy");
            document.body.removeChild(temporaryInput);
            if (!didCopy) { throw new Error("Clipboard copy failed"); }

        }

        if (toastSuccess) {

            // Confirm the copy through the normal Portal toast system
            toastSuccess({ title: "Copied", message: `${label} copied to clipboard.` });

        }

        return true;


    } catch (error) {

        if (toastError) {

            // Leave the generated code visible for manual copying if browser permissions block the clipboard
            toastError({ title: "Copy failed", message: "Select the code and copy it manually." });

        }

        return false;

    }

};


